export const permissionList = [
  {
    value: 'quotation',
    label: 'Quotation',
    children: [
      { value: 'quotation.list', label: 'List', parent: true },

      // Shipping Quotation
      { value: 'quotation.view.shipping', label: 'View Shipping', groupBy: 'shipping' },
      { value: 'quotation.create.shipping', label: 'Create Shipping', groupBy: 'shipping' },
      { value: 'quotation.update.shipping', label: 'Update Shipping', groupBy: 'shipping' },
      { value: 'quotation.delete.shipping', label: 'Delete Shipping', groupBy: 'shipping' },
      { value: 'quotation.approve.shipping', label: 'Approve Shipping', groupBy: 'shipping' },

      // Trucking Quotation
      { value: 'quotation.view.trucking', label: 'View Trucking', groupBy: 'trucking' },
      { value: 'quotation.create.trucking', label: 'Create Trucking', groupBy: 'trucking' },
      { value: 'quotation.update.trucking', label: 'Update Trucking', groupBy: 'trucking' },
      { value: 'quotation.delete.trucking', label: 'Delete Trucking', groupBy: 'trucking' },
      { value: 'quotation.approve.trucking', label: 'Approve Trucking', groupBy: 'trucking' },

      // Input / Additional Permissions
      { value: 'quotation.input.baf_percentage', label: 'BAF Percentage', groupBy: 'input' },
      { value: 'client.create', label: 'Add New Client', groupBy: 'input' },
      { value: 'vehicle.create', label: 'Add New Vehicle', groupBy: 'input' },
    ],
  },

  //  Booking
  {
    value: 'booking',
    label: 'Booking',
    children: [
      { value: 'booking.list', label: 'Booking List', parent: true },
      { value: 'booking.view', label: 'View Booking' },
      { value: 'booking.create', label: 'Create Booking' },
      { value: 'booking.update', label: 'Update Booking' },
      { value: 'booking.export.shipping', label: 'Export Booking (Shipping)' },
      { value: 'booking.export.trucking', label: 'Export Booking (Trucking)' },
      { value: 'booking.export.toyota', label: 'Export Booking (Toyota)' },
      { value: 'booking.submit', label: 'Submit Booking' },
    ],
  },

  //   VOF
  {
    value: 'vof',
    label: 'VOF',
    children: [
      { value: 'vof.list', label: 'VOF List', parent: true },
      { value: 'vof.view', label: 'View VOF' },
      { value: 'vof.create', label: 'Create VOF' },
      { value: 'vof.update', label: 'Update VOF' },
      { value: 'vof.approve', label: 'Approve VOF' },

      // Additional Permissions
      { value: 'consignee.create', label: 'Add New Consignee', groupBy: 'additional' },
    ],
  },

  //   Booking Item
  {
    value: 'booking_item',
    label: 'Booking Item',
    children: [
      { value: 'booking_item.list', label: 'Booking Item List', parent: true },
      { value: 'booking_item.update', label: 'Update Booking Item' },
    ],
  },

  //   Trucking
  {
    value: 'trucking',
    label: 'Trucking',
    children: [
      { value: 'trucking.list', label: 'Trucking List', parent: true },
      { value: 'trucking.update', label: 'Update Trucking List', parent: true },
    ],
  },

  //   Shipping Order
  {
    value: 'sof',
    label: 'Shipping Order',
    children: [
      { value: 'sof.list', label: 'SOF List', parent: true },
      { value: 'sof.view', label: 'View SOF' },
      { value: 'sof.create', label: 'Create SOF' },
      { value: 'sof.update', label: 'Update SOF' },
    ],
  },

  //  Delivery Receipt
  {
    value: 'dr',
    label: 'Delivery Receipt',
    children: [
      { value: 'dr.list', label: 'DR List', parent: true },
      { value: 'dr.view', label: 'View DR' },
      { value: 'dr.create', label: 'Create DR' },
      { value: 'dr.update', label: 'Update DR' },
      { value: 'dr.export', label: 'Print Delivery Receipt' },
    ],
  },

  //  Invoice Summary
  {
    value: 'invoice',
    label: 'Invoice Summary',
    children: [
      // { value: 'invoice.list', label: 'Invoice List' },
      // { value: 'invoice.view', label: 'View Invoice' },
    ],
  },

  //   Load/Unload Setup
  {
    value: 'load_unload',
    label: 'Load / Unload',
    children: [
      { value: 'load-and-unload.list', label: 'Load/Unload List', parent: true },
      { value: 'load-and-unload.export', label: 'Load/Unload Export' },
    ],
  },

  //   Vessel List Setup
  {
    value: 'vessel',
    label: 'Vessel Management',
    children: [
      { value: 'vessel.list', label: 'Vessel List', parent: true },
      { value: 'vessel.view', label: 'View Vessel Specs' },
      { value: 'vessel.create', label: 'Add Vessel' },
      { value: 'vessel.update', label: 'Update Vessel' },
    ],
  },

  //   Vessel Route Setup
  {
    value: 'vessel.route',
    label: 'Vessel Route',
    children: [
      { value: 'vessel.route.list', label: 'Vessel Route List', parent: true },
      { value: 'vessel.route.view', label: 'View Vessel Route' },
      { value: 'vessel.route.create', label: 'Add Route' },
      { value: 'vessel.route.update', label: 'Update Route' },
    ],
  },

  //   Vessel Schedule Setup
  {
    value: 'vessel.schedule',
    label: 'Vessel Schedule',
    children: [
      { value: 'vessel.schedule.list', label: 'Vessel Schedule List', parent: true },
      { value: 'vessel.schedule.view', label: 'View Vessel Schedule' },
      { value: 'vessel.schedule.generate', label: 'Generate Schedule' },
      { value: 'vessel.schedule.update', label: 'Update Schedule' },
      { value: 'vessel.schedule.delete', label: 'Delete Schedule' },
    ],
  },

  //   Rates List Setup
  {
    value: 'rates',
    label: 'Rates Entry',
    children: [
      { value: 'rates.list', label: 'Rates Entry List', parent: true },
      { value: 'rates.create', label: 'Add Rates Entry' },
      { value: 'rates.update', label: 'Update Rates Entry' },
      { value: 'rates.delete', label: 'Delete Rates Entry' },
    ],
  },

  //   Rates Toyota Setup
  {
    value: 'rates.toyota',
    label: 'Rates Entry (Toyota)',
    children: [
      // Toyota Main Rates
      { value: 'rates.toyota.list', label: 'Toyota Rates Entry List', parent: true },
      { value: 'rates.toyota.main.create', label: 'Add Toyota Rate' },
      { value: 'rates.toyota.main.update', label: 'Update Toyota Rate' },
      { value: 'rates.toyota.main.delete', label: 'Delete Toyota Rate' },

      // Toyota Vehicle
      { value: 'rates.toyota.vehicle', label: 'Toyota Vehicle List', groupBy: 'vehicle' },
      { value: 'rates.toyota.vehicle.view', label: 'View Toyota Vehicle', groupBy: 'vehicle' },
      { value: 'rates.toyota.vehicle.create', label: 'Create Toyota Vehicle', groupBy: 'vehicle' },
      { value: 'rates.toyota.vehicle.update', label: 'Update Toyota Vehicle', groupBy: 'vehicle' },

      // Toyota Location Rates
      { value: 'rates.toyota.location', label: 'Location Rate List', groupBy: 'location' },
      { value: 'rates.toyota.location.view', label: 'View Location Rate', groupBy: 'location' },
      { value: 'rates.toyota.location.create', label: 'Add Location Rate', groupBy: 'location' },
      { value: 'rates.toyota.location.update', label: 'Update Location Rate', groupBy: 'location' },
      { value: 'rates.toyota.location.delete', label: 'Delete Location Rate', groupBy: 'location' },
    ],
  },

  //   Special/Other Rate List Setup
  {
    value: 'rates.special',
    label: 'Special/Other Rates',
    children: [
      { value: 'rates.special.list', label: 'Rates Entry List', parent: true },
      { value: 'rates.special.view', label: 'View Rates Entry' },
      { value: 'rates.special.create', label: 'Add Rates Entry' },
      { value: 'rates.special.update', label: 'Update Rates Entry' },
      { value: 'rates.special.delete', label: 'Delete Rates Entry' },
    ],
  },

  //   Client Setup
  {
    value: 'client',
    label: 'Client Setup',
    children: [
      { value: 'client.list', label: 'Client List', parent: true },
      { value: 'client.view', label: 'View Client' },
      { value: 'client.create', label: 'Add Client' },
      { value: 'client.update', label: 'Update Client' },

      // Consignee
      { value: 'consignee.create', label: 'Add Consignee', groupBy: 'consignee' },
      { value: 'consignee.update', label: 'Update Consignee', groupBy: 'consignee' },
    ],
  },

  //   Island Setup
  {
    value: 'island',
    label: 'Island Setup',
    children: [
      { value: 'island.list', label: 'Island List', parent: true },
      { value: 'island.view', label: 'View Island' },
      { value: 'island.create', label: 'Add Island' },
      { value: 'island.update', label: 'Update Island' },
    ],
  },

  //   Ports Setup
  {
    value: 'port',
    label: 'Ports Setup',
    children: [
      { value: 'port.list', label: 'Port List', parent: true },
      { value: 'port.view', label: 'View Port' },
      { value: 'port.create', label: 'Add Port' },
      { value: 'port.update', label: 'Update Port' },
    ],
  },

  //   Vehicles Setup
  {
    value: 'vehicle',
    label: 'Vehicles Setup',
    children: [
      { value: 'vehicle.list', label: 'Vehicle List', parent: true },
      { value: 'vehicle.view', label: 'View Vehicle' },
      { value: 'vehicle.create', label: 'Add Vehicle' },
      { value: 'vehicle.update', label: 'Update Vehicle' },
    ],
  },

  //   BAF Setup
  {
    value: 'baf',
    label: 'BAF Setup',
    children: [
      { value: 'baf.list', label: 'BAF List', parent: true },
      { value: 'baf.view', label: 'View Price' },
      { value: 'baf.create', label: 'Add Price' },
      { value: 'baf.update', label: 'Update Price' },
      { value: 'baf.oil.update', label: 'Update Oil Price' },
    ],
  },

  //   Quotation Terms Setup
  {
    value: 'quotationTerms',
    label: 'Quotation Terms Setup',
    children: [
      { value: 'quotationTerms.list', label: 'Quotation Terms List', parent: true },
      { value: 'quotationTerms.create', label: 'Add Term' },
      { value: 'quotationTerms.update', label: 'Update Term' },
    ],
  },

  //   Terms and Conditions Setup
  {
    value: 'termsCondition',
    label: 'Terms and Conditions Setup',
    children: [
      { value: 'termsCondition.list', label: 'T&C List', parent: true },
      { value: 'termsCondition.create', label: 'Add T&C' },
      { value: 'termsCondition.update', label: 'Update T&C' },
    ],
  },

  //   Subjects Setup
  {
    value: 'subjects',
    label: 'Subjects Setup',
    children: [
      { value: 'subjects.list', label: 'Subjects List', parent: true },
      { value: 'subjects.create', label: 'Add Subject' },
      { value: 'subjects.update', label: 'Update Subject' },
    ],
  },

  //   Car Carrier Setup
  {
    value: 'carrier',
    label: 'Car Carrier Setup',
    children: [
      { value: 'carrier.list', label: 'Car Carrier List', parent: true },
      { value: 'carrier.view', label: 'View Car Carrier' },
      { value: 'carrier.create', label: 'Add Car Carrier' },
      { value: 'carrier.update', label: 'Update Car Carrier' },
    ],
  },

  //   Logistics Setup
  {
    value: 'logistics',
    label: 'Logistics Service Setup',
    children: [
      { value: 'logistics.list', label: 'Logistics Service List', parent: true },
      { value: 'logistics.create', label: 'Add Logistic' },
      { value: 'logistics.update', label: 'Update Logistic' },
    ],
  },

  //   Disclaimer Setup
  {
    value: 'disclaimer',
    label: 'Disclaimer Setup',
    children: [
      { value: 'disclaimer.list', label: 'Disclaimer List', parent: true },
      { value: 'disclaimer.create', label: 'Add Disclaimer' },
      { value: 'disclaimer.update', label: 'Update Disclaimer' },
    ],
  },

  //   Registration Setup
  {
    value: 'registration',
    label: 'Registration Link Setup',
    children: [
      { value: 'registration.list', label: 'Registration Link List', parent: true },
      { value: 'registration.create', label: 'Add Link' },
      { value: 'registration.reactivate', label: 'Reactivate Link' },
      { value: 'registration.delete', label: 'Delete Link' },
    ],
  },

  //   Users Setup
  {
    value: 'users',
    label: 'Users Setup',
    children: [
      { value: 'users.list', label: 'User List', parent: true },
      { value: 'users.view', label: 'View User' },
      { value: 'users.create', label: 'Add User' },
      { value: 'users.update', label: 'Update User' },
    ],
  },

  // //   Permission Setup
  // {
  //   value: 'permission',
  //   label: 'Permission Role Management',
  //   children: [
  //     { value: 'permission.list', label: 'Permission Role List', parent: true },
  //     { value: 'vessel.view', label: 'View Permission Role' },
  //     { value: 'vessel.create', label: 'Add Permission Role' },
  //     { value: 'vessel.update', label: 'Update Permission Role' },
  //   ],
  // },
]

export const requiredPermissions = {
  quotation: {
    tr: {
      code: 'tr',
      permissionCode: {
        create: 'quotation.create.trucking',
        update: 'quotation.update.trucking',
        view: 'quotation.view.trucking',
        delete: 'quotation.delete.trucking',
        approve: 'quotation.approve.trucking',
      }
    },
    st: {
      code: 'st',
      permissionCode: {
        create: 'quotation.create.shipping',
        update: 'quotation.update.shipping',
        view: 'quotation.view.shipping',
        delete: 'quotation.delete.shipping',
        approve: 'quotation.approve.shipping',
      }
    },
    input: {
      permissionCode: {
        baf: 'quotation.input.baf_percentage',
        addNewClient: 'client.create',
        addNewVehicle: 'vehicle.create',
      }
    },
  },
  booking: {
    code: 'booking',
    permissionCode: {
      list: 'booking.list',
      create: 'booking.create',
      update: 'booking.update',
      view: 'booking.view',
      delete: 'booking.delete',
      print: {
        st: 'booking.export.shipping',
        tr: 'booking.export.trucking',
        toyota: 'booking.export.toyota',
        all: ['booking.export.shipping', 'booking.export.trucking', 'booking.export.toyota']
      },
    }
  },
  vof: {
    code: 'vof',
    permissionCode: {
      list: 'vof.list',
      view: 'vof.view',
      create: 'vof.create',
      update: 'vof.update',
      approve: 'vof.approve',
      input: {
        addNewConsignee: 'consignee.create'
      },
    }
  },
  bookingItem: {
    code: 'booking_item',
    permissionCode: {
      list: 'booking_item.list',
      create: 'booking_item.create',
      update: 'booking_item.update',
    }
  },
  trucking: {
    code: 'trucking',
    permissionCode: {
      list: 'trucking.list',
      update: 'trucking.update',
    }
  },
  sof: {
    code: 'sof',
    permissionCode: {
      list: 'sof.list',
      create: 'sof.create',
      update: 'sof.update',
      view: 'sof.view',
      delete: 'sof.delete',
      print: 'sof.export',
    }
  },
  dr: {
    code: 'dr',
    permissionCode: {
      list: 'dr.list',
      create: 'dr.create',
      update: 'dr.update',
      view: 'dr.view',
      delete: 'dr.delete',
      print: 'dr.export',
    }
  },
  vessel: {
    list: {
      code: 'vessel',
      permissionCode: {
        list: 'vessel.list',
        create: 'vessel.create',
        update: 'vessel.update',
        view: 'vessel.view',
        delete: 'vessel.delete',
      }
    },
    route: {
      code: 'vessel.route',
      permissionCode: {
        list: 'vessel.route.list',
        create: 'vessel.route.create',
        update: 'vessel.route.update',
        view: 'vessel.route.view',
        delete: 'vessel.route.delete',
      }
    },
    schedule: {
      code: 'vessel.schedule',
      permissionCode: {
        list: 'vessel.schedule.list',
        create: 'vessel.schedule.generate',
        update: 'vessel.schedule.update',
        view: 'vessel.schedule.view',
        delete: 'vessel.schedule.delete',
      }
    },
  },
  rates: {
    general: {
      code: 'rates',
      permission: {
        list: 'rates.list',
        create: 'rates.create',
        update: 'rates.update',
        view: 'rates.view',
        delete: 'rates.delete',
      }
    },
    toyota: {
      code: 'rates.toyota',
      permission: {
        main: {
          list: 'rates.toyota.main.list',
          create: 'rates.toyota.main.create',
          update: 'rates.toyota.main.update',
          view: 'rates.toyota.main.view',
          delete: 'rates.toyota.main.delete',
        },
        vehicle: {
          list: 'rates.toyota.vehicle.list',
          create: 'rates.toyota.vehicle.create',
          update: 'rates.toyota.vehicle.update',
          view: 'rates.toyota.vehicle.view',
          delete: 'rates.toyota.vehicle.delete',
        },
        location: {
          list: 'rates.toyota.location.list',
          create: 'rates.toyota.location.create',
          update: 'rates.toyota.location.update',
          view: 'rates.toyota.location.view',
          delete: 'rates.toyota.location.delete',
        }
      }
    },
    special: {
      code: 'rates.special',
      permission: {
        list: 'rates.special.list',
        create: 'rates.special.create',
        update: 'rates.special.update',
        view: 'rates.special.view',
        delete: 'rates.special.delete',
      }
    },
  },
  setup: {
    client: {
      code: 'client',
      permissionCode: {
        list: 'client.list',
        create: 'client.create',
        update: 'client.update',
        view: 'client.view',
        delete: 'client.delete',
      }
    },
    consignee: {
      code: 'consignee',
      permissionCode: {
        create: 'consignee.create',
        update: 'consignee.update',
      }
    },
    island: {
      code: 'island',
      permission: {
        list: 'island.list',
        create: 'island.create',
        update: 'island.update',
        view: 'island.view',
        delete: 'island.delete',
      }
    },
    ports: {
      code: 'port',
      permission: {
        list: 'port.list',
        create: 'port.create',
        update: 'port.update',
        view: 'port.view',
        delete: 'port.delete',
      }
    },
    vehicles: {
      code: 'vehicle',
      permission: {
        list: 'vehicle.list',
        create: 'vehicle.create',
        update: 'vehicle.update',
        view: 'vehicle.view',
        delete: 'vehicle.delete',
      }
    },
    baf: {
      code: 'baf',
      permission: {
        list: 'baf.list',
        create: 'baf.create',
        update: 'baf.update',
        view: 'baf.view',
        delete: 'baf.delete',
        oil: {
          update: 'baf.oil.update'
        }
      }
    },
    quotationTerms: {
      code: 'quotationTerms',
      permission: {
        list: 'quotationTerms.list',
        create: 'quotationTerms.create',
        update: 'quotationTerms.update',
        view: 'quotationTerms.view',
        delete: 'quotationTerms.delete',
      }
    },
    termsCondition: {
      code: 'termsCondition',
      permission: {
        list: 'termsCondition.list',
        create: 'termsCondition.create',
        update: 'termsCondition.update',
        view: 'termsCondition.view',
        delete: 'termsCondition.delete',
      }
    },
    subjects: {
      code: 'subjects',
      permission: {
        list: 'subjects.list',
        create: 'subjects.create',
        update: 'subjects.update',
        view: 'subjects.view',
        delete: 'subjects.delete',
      }
    },
    carrier: {
      code: 'carrier',
      permission: {
        list: 'carrier.list',
        create: 'carrier.create',
        update: 'carrier.update',
        view: 'carrier.view',
        delete: 'carrier.delete',
      }
    },
    logistics: {
      code: 'logistics',
      permission: {
        list: 'logistics.list',
        create: 'logistics.create',
        update: 'logistics.update',
        view: 'logistics.view',
        delete: 'logistics.delete',
      }
    },
    disclaimer: {
      code: 'disclaimer',
      permission: {
        list: 'disclaimer.list',
        create: 'disclaimer.create',
        update: 'disclaimer.update',
        view: 'disclaimer.view',
        delete: 'disclaimer.delete',
      }
    },
  },
  registration: {
    code: 'registration',
    permission: {
      list: 'registration.list',
      create: 'registration.create',
      reactivate: 'registration.reactivate',
      delete: 'registration.delete',
    }
  },
  users: {
    code: 'users',
    permission: {
      list: 'users.list',
      view: 'users.view',
      create: 'users.create',
      update: 'users.update',
      delete: 'users.delete',
    }
  },
}

export const permissionRequestConfig = {
  system: 'qbs',
  request: 'permission',
  type: {
    authUserList: 'getFlattenedRolePermissionsAndUserPermissions',
    roles: {
      list: 'listRolePermission',
      create: 'createRolePermission',
      view: 'viewRolePermission',
      update: 'updateRolePermission',
      delete: 'deleteRolePermission',
    },
    user: {
      view: 'getSelectedUserRolePermissionsAndUserPermissions',
      update: 'updatePermission',
    }
  },
}
